
import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { UserEditFavoriteStore } from "../../stores/user/UserEditFavoriteStore";
import CalendarEvent from "./CalendarEvent.vue";

@Component({
    components: {
        CalendarEvent,
    },
})
export default class GlobalCalendarEvent extends Vue {
    @Prop() conferenceListItem!: ConferenceListItem;
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    userEditFavoriteStore: UserEditFavoriteStore = this.container.get(UserEditFavoriteStore);

    addToFavorites() {
        if (
            !this.authStore.user?.favorites?.conferenceIds?.includes(
                this.conferenceListItem.conferenceid,
            )
        ) {
            this.authStore.user?.favorites?.conferenceIds?.push(
                this.conferenceListItem.conferenceid,
            );
            this.userEditFavoriteStore.addConference(this.conferenceListItem.conferenceid);
        }
    }
}
